import { JwtPayloadType } from '@/types/jwtTypes';
import { Permissions } from '@/consts/permissions';

/**
 * Returns the effective house ID for API paths and current-company UI.
 *
 * For ATG admins: returns cookieValue when present and non-empty, otherwise jwt.houseId.
 * For all other roles: always returns jwt.houseId, regardless of cookie.
 *
 * This is a pure function safe to call in both client hooks and Next.js server components.
 * It ensures a non-admin user who manually crafts the houseOverride cookie cannot switch
 * house context — the API will still 401/403 them, but the UI will not attempt the requests.
 */
export const getEffectiveHouseId = (
    userDecoded: Pick<JwtPayloadType, 'authorities' | 'houseId'>,
    cookieValue?: string
): string => {
    const isAtgAdmin = userDecoded.authorities.includes(Permissions.ROLE_ATG_ADMIN);
    if (isAtgAdmin && cookieValue) {
        return cookieValue;
    }
    return userDecoded.houseId;
};
